export const status_text = {
	positive: '<span><i class="fas fa-check-circle blue-status-color" aria-hidden="true"></i></span>',
	negative: '<span><i class="fas fa-times-circle red-status-color" aria-hidden="true"></i></span>',
	warning: '<span><i class="fas fa-exclamation-circle amber-status-color" aria-hidden="true"></i></span>',
}

export const cols = [
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'type',
		fieldHeader: 'Type',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'status',
		fieldHeader: 'Status',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header fixedNumber',
		className: 'fixedNumber',
		show: true,
		accessor: 'documentNumber',
		fieldHeader: 'Document No.',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'consignee',
		fieldHeader: 'Consignee',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'reprocess',
		fieldHeader: 'Reprocess',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'source',
		fieldHeader: 'Source',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'destination',
		fieldHeader: 'Destination',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'userId',
		fieldHeader: 'Created By',
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'createTime',
		fieldHeader: 'Create Time',
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'aging',
		fieldHeader: 'Aging (hh:mm:ss)',
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'lastUpdated',
		fieldHeader: 'Last Updated',
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'updatedBy',
		fieldHeader: 'Updated By',
	},
	{
		headerClassName: 'data-table header errorDetails no-sorting',
		className: 'errorDetails',
		show: true,
		accessor: 'errorDetails',
		fieldHeader: 'Error Details',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header messageDetails no-sorting',
		className: 'messageDetails',
		show: true,
		accessor: 'messageDetails',
		fieldHeader: 'Message Details',
		isActionLink: true,
	},
	{
		headerClassName: 'data-table header ',
		show: true,
		accessor: 'historyLogId',
		fieldHeader: 'id',
	},
]

export const notificationCols = [
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'itemType',
		fieldHeader: 'Type',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'status',
		fieldHeader: 'Status',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header fixedNumber',
		className: 'fixedNumber',
		show: true,
		accessor: 'documentNumber',
		fieldHeader: 'Document No.',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'createdDate',
		fieldHeader: 'Create Time',
	},
	{
		headerClassName: 'data-table header resolvedDate',
		className: 'resolvedDate',
		show: true,
		accessor: 'resolvedDate',
		fieldHeader: 'Resolved Time',
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'aging',
		fieldHeader: 'Aging (hh:mm:ss)',
	},
	{
		headerClassName: 'data-table header messageDetails no-sorting',
		className: 'messageDetails',
		show: true,
		accessor: 'messageDetails',
		fieldHeader: 'Message Details',
		isActionLink: true,
	},
	{
		headerClassName: 'data-table header ',
		show: true,
		accessor: 'notificationId',
		fieldHeader: 'id',
	},
]
export const colsLogs = [
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'documentNumber',
		fieldHeader: 'Document Number',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'type',
		fieldHeader: 'Document Type',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'status',
		fieldHeader: 'Status',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'messageType',
		fieldHeader: 'Message Type',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'source',
		fieldHeader: 'Source',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'description',
		fieldHeader: 'Description',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'destination',
		fieldHeader: 'Destination',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'timestamp',
		fieldHeader: 'Date',
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'userId',
		fieldHeader: 'Logged By',
	},
	{
		headerClassName: 'data-table header messageDetails no-sorting',
		className: 'messageDetails',
		show: true,
		accessor: 'messageDetails',
		fieldHeader: 'Message Details',
		isActionLink: true,
	},
	{
		headerClassName: 'data-table header ',
		show: true,
		accessor: 'logId',
		fieldHeader: 'id',
	},
]

export const colsReprocess = [
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'documentNumber',
		fieldHeader: 'Document Number',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header no-sorting',
		className: 'no-sorting',
		show: true,
		accessor: 'itemType',
		fieldHeader: 'Document Type',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header ',
		show: true,
		accessor: 'customerBeCode',
		fieldHeader: 'Customer (BE code)',
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'messageType',
		fieldHeader: 'Message Type',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'source',
		fieldHeader: 'Source',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header',
		show: true,
		accessor: 'createdDate',
		fieldHeader: 'Date',
	},
	{
		headerClassName: 'data-table header messageDetails no-sorting',
		className: 'messageDetails',
		show: true,
		accessor: 'messageDetails',
		fieldHeader: 'Message Details',
		isActionLink: true,
	},
	{
		headerClassName: 'data-table header pendingReason no-sorting',
		className: 'pendingReason',
		show: true,
		accessor: 'pendingReason',
		fieldHeader: 'Pending Reason',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header ',
		show: true,
		accessor: 'id',
		fieldHeader: 'id',
	},
]

export const colsUploadCharge = [
	{
		headerClassName: 'data-table header no-sorting',
		show: true,
		accessor: 'fileName',
		fieldHeader: 'File Name',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header no-sorting',
		show: true,
		accessor: 'category',
		fieldHeader: 'Category',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header no-sorting',
		show: true,
		accessor: 'status',
		fieldHeader: 'Status',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header no-sorting',
		show: true,
		accessor: 'createdBy',
		fieldHeader: 'Uploaded By',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header no-sorting',
		show: true,
		accessor: 'createdDate',
		fieldHeader: 'Uploaded Date',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header messageDetails no-sorting',
		className: 'messageDetails',
		show: true,
		accessor: 'errorLogURl',
		fieldHeader: 'Error Details',
		isActionLink: true,
	},
	{
		headerClassName: 'data-table header output-file no-sorting',
		className: 'output-file',
		show: true,
		accessor: 'downloadOutputFile',
		fieldHeader: 'Output File',
		isActionLink: false,
	},
]

export const colsDownloadCharge = [
	{
		headerClassName: 'data-table header no-sorting',
		show: false,
		accessor: 'id',
		fieldHeader: 'GUID',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header no-sorting',
		show: true,
		accessor: 'fileName',
		fieldHeader: 'File Name',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header no-sorting',
		show: true,
		accessor: 'status',
		fieldHeader: 'Status',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header no-sorting',
		show: true,
		accessor: 'createdBy',
		fieldHeader: 'Downloaded By',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header no-sorting',
		show: true,
		accessor: 'createdDate',
		fieldHeader: 'Requested At',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header no-sorting',
		show: true,
		accessor: 'exportedDate',
		fieldHeader: 'Processed At',
		isActionLink: false,
	},
	{
		headerClassName: 'data-table header messageDetails no-sorting',
		className: 'messageDetails',
		show: true,
		accessor: 'errorLogURl',
		fieldHeader: 'Summary',
		isActionLink: true,
	},
]

export const TABS: any[] = [
	{
		id: 1,
		title: 'Open Exceptions',
		emptyLabel: '',
	},
	{
		id: 2,
		title: 'Closed Exceptions',
		emptyLabel: '',
	},
]
export const TABS_NOTIFICATION: any[] = [
	{
		id: 1,
		title: 'Open Notifications',
		emptyLabel: '',
	},
	{
		id: 2,
		title: 'Closed Notifications',
		emptyLabel: '',
	},
]

export const sales_order_icon = {
	new: '<span><i class="fas fa-external-link-alt blue-status-color" aria-hidden="true"></i></span>',
	jobClose: '<span><i class="fas fa-info-circle blue-status-color" aria-hidden="true"></i></span>',
}
